export * from './types.js';

import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'forms',
  name: 'فرم‌ها',
  description: 'فرم‌ساز و مدیریت پیام‌ها',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_forms', 'cms_form_submissions'],
};

export const formsModule: ModuleDefinition = {
  id: 'forms',
  name: 'فرم‌ها',
  description: 'فرم‌ساز و مدیریت پیام‌ها',
  version: '0.1.0',
  icon: 'ClipboardList',
  category: 'communication',
  dependencies: [],
  tables: ['cms_forms', 'cms_form_submissions'],
  adminRoutes: [
    {
      path: '/forms',
      component: () => import('./admin/FormsListPage').then(m => ({ default: m.FormsListPage })),
      permission: 'forms.read',
      label: 'فرم‌ها',
      icon: 'ClipboardList',
    },
    {
      path: '/forms/new',
      component: () => import('./admin/FormBuilderPage').then(m => ({ default: m.FormBuilderPage })),
      permission: 'forms.create',
      label: 'فرم جدید',
    },
    {
      path: '/forms/edit/:id',
      component: () => import('./admin/FormBuilderPage').then(m => ({ default: m.FormBuilderPage })),
      permission: 'forms.update',
      label: 'ویرایش فرم',
    },
    {
      path: '/forms/:formId/submissions',
      component: () => import('./admin/FormSubmissionsPage').then(m => ({ default: m.FormSubmissionsPage })),
      permission: 'forms.read_submissions',
      label: 'پاسخ‌های فرم',
    },
  ],
};
